module.exports = __webpack_public_path__ + "img/中圈.53ac0a25.png";